module.exports = __webpack_public_path__ + "img/interpack-inactive.125c5c3e.svg";